import reducer from './assets';
import { actionCreators, AssetsActionType } from './assets.actionCreators';
import * as actionTypes from './assets.actionTypes';

export * from './assets';
export * from './assets.selectors';
export type ActionType = AssetsActionType;
export { actionTypes, actionCreators };
export default reducer;
